import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@shared/modules/auth/services/auth.service';
import { WINDOW } from '@shared/services/window.service';

@Component({
  selector: 'home-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})
export class ContactComponent implements OnInit {

  freshDeskSrc: SafeResourceUrl = null;

  readonly DEFAULT_CATEGORY = '';
  readonly DEFAULT_DESCRIPTION = '';
  readonly DEFAULT_EMAIL = '';
  readonly DEFAULT_FROM_TITLE = 'Contact Us';
  readonly DEFAULT_SUBJECT = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private sanitizer: DomSanitizer,
    @Inject(WINDOW) private window: Window | null
  ) { }

  ngOnInit() {

    // Scroll to top
    if (this.window) {
      this.window.scrollTo(0, 0);
    }

    // Pre-populated fields
    const description = this.activatedRoute.snapshot.queryParamMap.get('des') || this.DEFAULT_DESCRIPTION;
    const email = this.authService.isAuthenticated() ? this.authService.getSessionInfo().Email : this.DEFAULT_EMAIL;
    const formTitle = this.activatedRoute.snapshot.queryParamMap.get('ft') || this.DEFAULT_FROM_TITLE;
    const subject = this.activatedRoute.snapshot.queryParamMap.get('s') || this.DEFAULT_SUBJECT;

    // Clean up query params
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {c: null, des: null, ft: null, s: null},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });

    // tslint:disable-next-line
    let src = `https://codingwithkids.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&formTitle=${formTitle}&submitTitle=Send&helpdesk_ticket[requester]=${email}&helpdesk_ticket[subject]=${subject}&helpdesk_ticket[description]=${description}&submitThanks=Thank+you+for+your+enquiry!+Any+second+you+should+receive+a+confirmation+email.+(If+you+have+not,+please,+resubmit+your+question+again+and+check+that+your+email+has+been+entered+correctly.)+We+will+respond+to+you+as+soon+as+possible.+Most+tickets+are+handled+within+one+business+day,+but+you+may+also+hear+from+us+in+just+a+couple+of+hours.&screenshot=No`;

    // Sanitizer the src
    this.freshDeskSrc = this.sanitizer.bypassSecurityTrustResourceUrl(src);
  }

}
